import React from 'react';

import { FontAwesomeIcon } from '@schoolinks/ui-components';
import { faAppleWhole } from '@fortawesome/pro-regular-svg-icons/faAppleWhole';
import { faFamily } from '@fortawesome/pro-regular-svg-icons/faFamily';

import { faGraduationCap } from '@fortawesome/pro-regular-svg-icons/faGraduationCap';

import { USER_TYPES } from 'constants/userTypes';
import {
  DASHBOARD,
  EL_DASHBOARD,
  ROOT,
  LOGIN,
  NEWSFEED,
} from 'routes/constants';

export const MIDDLE_HIGH_SCHOOL_MODE_KEY = 'secondary';
export const ELEMENTARY_MODE_KEY = 'elementary';
export const GUARDIAN_MODE_KEY = 'guardian';

export const ALLOWED_NAVIGATE_ROUTES = [
  ROOT,
  LOGIN,
  NEWSFEED,
  DASHBOARD,
  EL_DASHBOARD,
];

export const DASHBOARD_MODES = Object.freeze({
  [ELEMENTARY_MODE_KEY]: {
    title: 'Elementary School',
    icon: <FontAwesomeIcon color="white" icon={faAppleWhole} />,
    route: EL_DASHBOARD,
  },
  [MIDDLE_HIGH_SCHOOL_MODE_KEY]: {
    title: 'Middle & High School',
    icon: <FontAwesomeIcon color="white" icon={faGraduationCap} />,
    route: DASHBOARD,
  },
  [GUARDIAN_MODE_KEY]: {
    title: 'Guardian',
    icon: <FontAwesomeIcon color="white" icon={faFamily} />,
    route: NEWSFEED,
  },
});

export const USER_MODE_MAP_BY_TYPE = {
  [USER_TYPES.K12_ADMIN]: [MIDDLE_HIGH_SCHOOL_MODE_KEY, ELEMENTARY_MODE_KEY],
  [USER_TYPES.MEMBER]: [GUARDIAN_MODE_KEY],
  [USER_TYPES.GUARDIAN]: [GUARDIAN_MODE_KEY],
};
